var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGive50Logo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 255.9 82.7",
    style: {
      enableBackground: "new 0 0 255.9 82.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.8,32.2v29c0,10-6.8,14.5-15.6,14.5c-4.9,0.1-9.6-1.3-13.7-4l3.1-5.8c3,1.9,6.4,2.9,9.8,3 c5.3,0,8.7-2.2,8.7-7.9v-3c-2.5,2.5-6,3.8-9.5,3.7c-8.3,0-14-6.2-14-15.1s5.7-15.1,14-15.1c3.8-0.1,7.4,1.4,10,4.2l0.5-3.5 L96.8,32.2z M89.2,46.7c0-4.9-3.3-8.3-7.9-8.3s-7.9,3.4-7.9,8.3s3.3,8.3,7.9,8.3S89.2,51.6,89.2,46.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.9,24.1c-0.1-2.5,1.9-4.5,4.3-4.6c0.1,0,0.3,0,0.4,0c2.5-0.1,4.6,1.8,4.7,4.3s-1.8,4.6-4.3,4.7 c-0.1,0-0.3,0-0.4,0c-2.5,0.1-4.6-1.7-4.7-4.2C99.9,24.3,99.9,24.2,99.9,24.1z M100.8,32.2h7.8v29.1h-7.8V32.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143,32.2l-12.2,29.1h-8.1l-12.2-29.1h8.5l3.7,9.4l4.2,11.5l4.1-11.5l3.7-9.4H143z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172,49.4h-22.2c0.5,3.7,3.7,6.1,8.3,6.1c2.9,0.1,5.7-0.9,8-2.8l4.3,4.5c-3.4,3.3-7.9,5.1-12.6,4.9 c-9.7,0-15.9-6-15.9-15.2c0-9.1,6.1-15.2,15.1-15.2C167.5,31.6,173.3,38.6,172,49.4z M149.9,44.2h14.8c-0.3-3.8-3.1-6.1-7.4-6.1 C153.3,38,150.5,40.3,149.9,44.2L149.9,44.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.6,48.3c0,8.1-6.5,13.5-16.3,13.5c-10.7,0-16.7-4.7-16.7-13.1h8.2c0,3.7,3.1,5.8,8.4,5.8 c5,0,8.1-2.5,8.1-6.4s-3-6.2-8.1-6.2h-15.5V20.1h29.6v7.4h-21.7v7.4h7.6C201.8,34.8,207.6,39.6,207.6,48.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.6,44.4V37c0-10.7,7.2-17.7,18.1-17.7s18,7,18,17.7v7.4c0,10.7-7.2,17.7-18,17.7S209.6,55.1,209.6,44.4z  M237.5,44.4V37c0-6.2-3.9-10.2-9.9-10.2s-9.9,4.1-9.9,10.2v7.4c0,6.1,3.8,10.2,9.9,10.2S237.5,50.5,237.5,44.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.3,4.3v66.9h51.4V4.3H7.3z M53,52.9c-6.3,0.1-11.3,5.3-11.2,11.5h-5.7C36.1,54.8,43.7,47,53,47V52.9z  M53,41.2c-12.4,0-22.5,10.4-22.5,23.2h-5.7c0-16,12.6-29.1,28.1-29.1L53,41.2z M53,29.2c-18.8,0-34.1,15.8-34.1,35.2h-5.7 C13.2,41.7,31,23.3,53,23.3L53,29.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGive50Logo);
export default __webpack_public_path__ + "static/media/give50logo.7f8d377d73654e7db309e0a03312f4b1.svg";
export { ForwardRef as ReactComponent };